<div class="desktop-container"></div>
<div class="define-container">
    <div class="desktop-content">
        <div class="header">
            <i class="icon-edponline-Bra-071" (click)="closeTermsConditions()"></i>
        </div>
        <div class="content">
            <div class="title">
                <p [innerHTML]="'pt.edp.edponline.house.terms.conditions.title' | translate"></p>
            </div>
            <div class="body">
                <p class="first-p" [innerHTML]="'pt.edp.edponline.house.terms.conditions.body.title' | translate"></p>
                <ul>
                    <li [innerHTML]="'pt.edp.edponline.house.terms.conditions.recommendations' | translate"></li>
                    <li [innerHTML]="'pt.edp.edponline.house.terms.conditions.efficiency.comparisons' | translate"></li>
                    <li [innerHTML]="'pt.edp.edponline.house.terms.conditions.consume.evolutions' | translate"></li>
                </ul>
            </div>
            <div class="footer">
                <p [innerHTML]="'pt.edp.edponline.house.terms.conditions.respond.pace' | translate"></p>
            </div>
            <div class="checkbox-container">
                <input type="checkbox" id="terms-conditions" class="checkbox" (change)="toggleAcceptTerms($event)" />
                <label for="terms-conditions">{{ "pt.edp.edponline.house.terms.conditions.terms.label" | translate }}</label>
                <a
                    class="terms-link"
                    href="{{ 'pt.edp.edponline.contract.define.resume.terms.and.conditions.link' | translate }}"
                    [edpExternalLink]="'pt.edp.edponline.contract.define.resume.terms.and.conditions.link' | translate"
                    target="_blank"
                >
                    {{ "pt.edp.edponline.house.terms.conditions.terms.link" | translate }}
                </a>
                <!-- TODO: LEAVE THIS COMMENTED OUT -->
                <!-- <ng-container *ngIf="!mobileSize; else tooltipInfo">
                    <span class="terms-link">{{"pt.edp.edponline.house.terms.conditions.terms.link" | translate}}</span>
                    <ng-container *ngTemplateOutlet="popoverTemplate"></ng-container>
                    <ng-template #popoverTemplate>
                        <edp-popover
                            class="terms-conditions-popover"
                            #popComponent
                            [popoverContent]="popoverContent"
                            [popPlacement]="'bottom'">
                            <span class="terms-link">{{"pt.edp.edponline.house.terms.conditions.terms.link" | translate}}</span> 
                        </edp-popover>
                        <ng-template #popoverContent>
                            <div [innerHTML]="templateKeyHTML | translate"></div>
                        </ng-template>
                    </ng-template>
                </ng-container>
                <ng-template #tooltipInfo>
                    <span class="terms-link" (click)="openTooltipModal()">{{"pt.edp.edponline.house.terms.conditions.terms.link" | translate}}</span> 
                </ng-template>  -->
            </div>
            <div class="button-container">
                <button
                    (click)="goToMoonShot()"
                    [disabled]="!acceptTerms"
                    [innerHTML]="'pt.edp.edponline.house.terms.conditions.button.title' | translate"
                ></button>
            </div>
        </div>
    </div>
</div>
